import { useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { ScrollFade } from 'designSystem/components/ScrollFade'
import { Text } from 'designSystem/components/Text'
import { RevisionFamilyCard } from 'features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard'
import type { RevisionFamilyMemberView } from 'features/knowledgeDocumentViewer/utils/pageRevisionFamily'
import React from 'react'

export type RevisionFamilyListProps = {
  members: readonly RevisionFamilyMemberView[]
  onSelectVersion?: (member: RevisionFamilyMemberView) => void
  onOpenInNewTab?: (member: RevisionFamilyMemberView) => void
}

export function RevisionFamilyList({
  members,
  onSelectVersion,
  onOpenInNewTab,
}: RevisionFamilyListProps): React.ReactElement | null {
  const { t } = useLingui()
  const memberCount = members.length
  if (memberCount === 0) return null

  // Require both handlers — hide Select/Open together if either is missing.
  const canActOnVersions =
    onSelectVersion !== undefined && onOpenInNewTab !== undefined

  return (
    <Box display='flex' direction='column' gap='sm' flex='one' minHeight='none'>
      <Box shrink={false}>
        <Text as='h4' variant='body' weight='semibold'>
          {t`Revisions (${memberCount})`}
        </Text>
      </Box>
      <ScrollFade>
        <Box display='flex' direction='column' gap='sm'>
          {members.map((member, index) => (
            <RevisionFamilyCard
              key={member.memberEntryId}
              member={member}
              isLatest={index === 0}
              onSelectVersion={canActOnVersions ? onSelectVersion : undefined}
              onOpenInNewTab={canActOnVersions ? onOpenInNewTab : undefined}
            />
          ))}
        </Box>
      </ScrollFade>
    </Box>
  )
}
